// extracted by mini-css-extract-plugin
module.exports = {"overlay":"NewsletterModal_overlay__eFA8h","modal":"NewsletterModal_modal___V5Qb","close":"NewsletterModal_close__SXaK0"};